import { render, staticRenderFns } from "./OdontogramaProcedimentoTabela.vue?vue&type=template&id=ba546990&scoped=true"
import script from "./OdontogramaProcedimentoTabela.vue?vue&type=script&lang=js"
export * from "./OdontogramaProcedimentoTabela.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaProcedimentoTabela.vue?vue&type=style&index=0&id=ba546990&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba546990",
  null
  
)

export default component.exports